import { tns } from 'tiny-slider/src/tiny-slider';
export const initSliders = () => {
    const sliderElements = document.querySelectorAll('.sliders');
    sliderElements.forEach((sliderElement) => {
        const element = sliderElement;
        const slider = element.querySelector('.slider');
        if (slider) {
            const buttonNavigation = slider.dataset.controls === '1';
            const dotsPagination = slider.dataset.nav === '1';
            const identifier = element.dataset.identifier;
            tns({
                container: `.sliders[data-identifier="${identifier}"] .slider`,
                items: 1,
                slideBy: 'page',
                mouseDrag: true,
                swipeAngle: false,
                speed: 500,
                controls: buttonNavigation,
                nav: dotsPagination,
                loop: true,
                center: true,
                arrowKeys: true,
                lazyload: false,
                preventScrollOnTouch: 'force',
                navPosition: 'bottom',
            });
        }
    });
};
export const initShowHideToggles = () => {
    const showToggles = document.querySelectorAll('.show-toggle');
    showToggles.forEach((toggle) => {
        if (!('target' in toggle.dataset)) {
            return;
        }
        const target = document.querySelector(toggle.dataset.target);
        if (target instanceof HTMLElement) {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();
                target.classList.toggle('shown');
                target.scrollIntoView({
                    behavior: 'smooth',
                });
            });
        }
    });
};
